import { Component, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EmailPositionFormComponent } from 'src/app/components/email-position-form/email-position-form.component';
import { TitleNameFormComponent } from '../../title-name-form/title-name-form.component';
import { PersonContactCardFormGroup } from './person-contact-card-form.helper';

@Component({
  selector: 'app-person-contact-form',
  imports: [TitleNameFormComponent, EmailPositionFormComponent],
  templateUrl: './person-contact-form.component.html',
  styleUrl: './person-contact-form.component.scss',
})
export class PersonContactFormComponent {
  formGroup = input.required<FormGroup<PersonContactCardFormGroup>>();
  /** When true, title is shown inside the name form (e.g. for section-e one-row layout). */
  showTitle = input<boolean>(false);
  disabled = input<boolean>(false);
}
